import React, { createContext, useContext } from 'react';

export function isExtensionPath(path: string) {
  return path.startsWith('/extension-ui');
}

const IsExtensionContext = createContext(false);

interface IsExtensionProviderProps {
  children: React.ReactNode;
}

export const IsExtensionProvider = ({ children }: IsExtensionProviderProps) => (
  <IsExtensionContext.Provider value>{children}</IsExtensionContext.Provider>
);

export const useIsExtension = () => {
  return useContext(IsExtensionContext);
};
